import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './contexts/AuthContext'
import Layout from './components/Layout'
import HomePage from './pages/HomePage'
import LoginPage from './pages/LoginPage'
import AdminDashboard from './pages/AdminDashboard'
import ArtistsPage from './pages/ArtistsPage'
import ReleasesPage from './pages/ReleasesPage'
import ManageArtistsPage from './pages/ManageArtistsPage'

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="login" element={<LoginPage />} />
        <Route path="artists" element={<ArtistsPage />} />
        <Route path="releases" element={<ReleasesPage />} />
        <Route
          path="admin"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="admin/artists"
          element={
            <ProtectedRoute>
              <ManageArtistsPage />
            </ProtectedRoute>
          }
        />
      </Route>
    </Routes>
  )
}

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth()

  if (isLoading) {
    return <div>Loading...</div>
  }

  if (!user || !user.isAdmin) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

export default App
